import { connect } from "react-redux";
import { providePopulateData } from "components/utility/hoc/PopulateData";
import _ from "underscore";
import { task } from "../../../lib/selectors/WritingSelectors";

var ReactTooltip = require("react-tooltip");

var CurrentUser = require("lib/account/CurrentUser");
var DataRouting = require("lib/routing/DataRouting");
var Formats = require("lib/academic/Formats");
var Skillsets = require("lib/academic/Skillsets");
var UIActions = require("lib/actions/UIActions");
var StudentMetrics = require("lib/data/StudentMetrics");

var Glyphicon = require("components/utility/icons/Glyphicon");
var NoActivityBlock = require("components/data/subjects/shared/NoActivityBlock");
var StudentDisplay = require("components/users/students/StudentDisplay");

var WritingSelectors = require("lib/selectors/WritingSelectors");
var WritingActions = require("lib/actions/WritingActions");
var ReadingActions = require("lib/actions/ReadingActions");
var ReadingSelectors = require("lib/selectors/ReadingSelectors");
var RosterSelectors = require("lib/selectors/RosterSelectors");
var ButtonDropdownOption = require("components/utility/ButtonDropdownOption");
var ButtonDropdown = require("components/utility/ButtonDropdown");

require("writing/activities/expanded_student_activities_table.scss");

function propsToConditions(props) {
  var conditions = _.pick(props,
    "startDate", "endDate", "textID", "textVariety", "userIDs", "dueDate"
  );

  return conditions;
}

@connect(
  (state, props) => ({
    loading: WritingSelectors.isLoadingResponses({ state }),
    books: ReadingSelectors.books({ state }),
    responses: WritingSelectors.responses({ state }),
    activities: WritingSelectors.activities({ state }),
    tasks: WritingSelectors.tasks({ state }),
    students: RosterSelectors.students({ state })
  }),
  (dispatch, props) => ({
    populateData: () => {
      // TODO: standardize FE requests
      // if the dataset of students is large, send multiple requests
      if ($wr.isLargeRequest(props.userIDs)) {
        var conditions = _.pick(props, "startDate", "endDate", "textID", "textVariety", "dueDate")
        var actionFunction = WritingActions.fetchResponses
        var options = { cache: true }
        
        return new Promise(function (resolve, reject) {
          // responses
          $wr.handleLargeRequest(dispatch, props.userIDs, conditions, actionFunction, options, function (results) {
            var responses = results
            actionFunction = WritingActions.fetchTasks
            options.embeds = ['task.task_items']
            // tasks
            $wr.handleLargeRequest(dispatch, props.userIDs, conditions, actionFunction, options, function (second_results) {
              var tasks = second_results
              resolve(_.compact(_.flatten(tasks.concat(responses))));
            })
          })
        }).catch(() => console.log("Responses and tasks failed to load"));
      } else {
        var responses = dispatch(WritingActions.fetchResponses({
          conditions: propsToConditions(props),
          cache: true
        }))

        var tasks = dispatch(WritingActions.fetchTasks({
          embeds: ['task.task_items'],
          conditions: propsToConditions(props),
          cache: true
        }))

        return Promise.all([responses, tasks]);
      }
    },
    fetchBook: (textID) => {
      dispatch(ReadingActions.batchFetchBook({ id: textID }))
    },
    toggleExpandedResponse: (responseID) => {
      dispatch(UIActions.toggleExpandedResponse({ responseID: responseID, expanded: true }));
    },
    fetchActivity: (activityID) => {
      dispatch(WritingActions.fetchActivity({ id: activityID, embeds: ["activity.format_summary"] }))
    }
  })
)
@providePopulateData({ waitForLoad: true })
class ExpandedStudentActivitiesTable extends React.Component {
  constructor(props) {
    super();
    autobind(this);
    // incomplete tasks would not be pulled by responses
    var incompleteTasks = _.where(props.tasks, { subject_type: StudentMetrics.TEACHER_PICKS_SUBJECTS.EXERCISE, completed_at: null })
    incompleteTasks = incompleteTasks.concat(_.where(props.tasks, { subject_type: ACTIVITY_SUBJECT_TYPE, completed_at: null }))
    
    var unifiedTaskItemArray = _.flatten(_.uniq(_.compact(_.pluck(props.tasks, 'task_items'))))
    var incompleteTaskItems = _.filter(unifiedTaskItemArray, (task_item) => {
      if (task_item && task_item.subject_type === StudentMetrics.TEACHER_PICKS_SUBJECTS.EXERCISE && task_item.draft) {
        return task_item
      }
    })
    incompleteTasks = incompleteTasks.concat(incompleteTaskItems)
    var allExercises = props.responses.concat(incompleteTasks)
    // get all userIDs of students who have activities
    var studentsWithExercisesIDs = _.compact(_.uniq(_.map(allExercises, exercise => exercise.user_id)))
    var studentsWithCompletedExercisesIDs = _.compact(_.uniq(_.map(allExercises, exercise => !exercise.draft && exercise.user_id )))
    // students without exercises
    var studentsWithoutExercises = _.filter([...props.userIDs], userID => !studentsWithExercisesIDs.includes(userID))
    var studentsWithoutCompletedExercises = _.filter([...props.userIDs], userID => !studentsWithCompletedExercisesIDs.includes(userID))
    // get book information
    _.each(allExercises, (item) => {
      if (item.text_id && item.text_id !== 'MISSING_TEXT_ID' && item.text_id !== '') {
        props.fetchBook(item.text_id)
      }
      // get activity information for responses
      if (item.activity_id) {
        props.fetchActivity(item.activity_id)
      }
      // get activity information for tasks
      if (item.subject_id) {
        props.fetchActivity(parseInt(item.subject_id))
      }
    })

    this.state = { studentsWithoutExercises, studentsWithoutCompletedExercises, incompleteTasks, allExercises, orderBy: STUDENT_NAME_ORDER }
  }

  handleActivityClick(e) {
    if (e.currentTarget.getAttribute('data-response-id')) {
      this.props.toggleExpandedResponse(e.currentTarget.getAttribute('data-response-id'))
    }
  }

  dateFormat(date) {
    let d = new Date(date);
    let ye = new Intl.DateTimeFormat('en', { year: 'numeric' }).format(d);
    let mo = new Intl.DateTimeFormat('en', { month: 'numeric' }).format(d);
    let da = new Intl.DateTimeFormat('en', { day: '2-digit' }).format(d);

    return `${mo}/${da}/${ye}`
  }

  renderSortContainer(activityDisplay) {
    var sort = ''
    if (activityDisplay && !_.isEmpty(activityDisplay)) {
      sort = (<div className="sortControlContainer hideOnPrint">
                <div className="sortControlCell">
                  Sort By: {this.renderSortControl()}
                </div>
              </div>)
    }
    return sort
  }

  renderSortControl() {
    var orderOptionText = (op) => {
      if (STUDENT_NAME_ORDER === op) {
        return "Student Name";
      } else if (LAST_ACTIVE === op) {
        return "Last Activity";
      } else if (ASSIGNED_DATE === op) {
        return "Date Assigned";
      } else if (DUE_DATE === op) {
        return "Due Date";
      } else {
        return StudentMetrics.getLabel(op);
      }
    }

    var renderOption = (op) => {
      return (
        <ButtonDropdownOption key={op} className=""
          text={orderOptionText(op)}
          onClick={this.changeSortBy.bind(this, op)}>
        </ButtonDropdownOption>
      );
    }

    var orderOptions = [];

    orderOptions.push(renderOption(STUDENT_NAME_ORDER));
    orderOptions.push(renderOption(LAST_ACTIVE));
    orderOptions.push(renderOption(ASSIGNED_DATE));
    orderOptions.push(renderOption(DUE_DATE));

    if (this.props.showGoals) {
      _.each(this.props.expectationMetrics, (metric) => {
        orderOptions.push(renderOption(metric));
      });

    } else {
      _.each(this.props.userMetricsColumns, (metric) => {
        orderOptions.push(renderOption(metric));
      });
    }

    var displayText = orderOptionText(this.state.orderBy);

    return (
      <ButtonDropdown dropdownDisplay="link" text={displayText}>
        { orderOptions}
      </ButtonDropdown>
    );
  }

  changeSortBy(orderBy) {
    this.setState({ orderBy });
  }
  // sorts user tables
  sortUserIDs() {
    var orderBy = this.state.orderBy;
    var students = _.filter(this.props.students, (student) => { return _.contains(this.props.userIDs, student.id) })
    students = $wr.sortByName(students, "flexName");
    if (orderBy == LAST_ACTIVE) {
      students = _.sortBy(students, (student) => { return student.last_active || "1970-01-01" }).reverse()
    } else if (orderBy == ASSIGNED_DATE) {
      students = _.sortBy(students, (student) => {
        var responses = _.where(this.props.responses, { user_id: student.id })
        var firstResponse = _.first(_.sortBy(responses, 'created_at'))
        return firstResponse ? firstResponse.created_at : "1970-01-01";
      })
    } else if (orderBy == DUE_DATE) {
      students = _.sortBy(students, (student) => {
        var responses = _.where(this.props.responses, { user_id: student.id })
        var firstResponse = _.first(_.sortBy(responses, 'due_date'))
        return firstResponse ? firstResponse.due_date : "1970-01-01";
      })
    }
    return _.pluck(students, 'id')
  }

  // sorts rows in tables
  sortExercises(allExerciseData) {
    var orderBy = this.state.orderBy;
     if (orderBy == DUE_DATE) {
      allExerciseData = _.sortBy(allExerciseData, 'due_date')
    } else {
      allExerciseData = _.sortBy(allExerciseData, 'created_at')
    }
    return allExerciseData
  }


  render() {
    var allExercises = [...this.state.allExercises]
    if (this.props.completed) {
      allExercises = this.props.responses
    } else if (this.props.assigned) {
      allExercises = [...this.state.incompleteTasks]
    }

    var allExerciseData = _.map(allExercises, (item) => {
      var activityData = {}
      activityData.created_at = item.created_at ? item.created_at: null
      activityData.due_date = item.due_date ? item.due_date : null
      activityData.text_id = item.text_id ? item.text_id : null
      activityData.activity_id = item.activity_id ? item.activity_id : parseInt(item.subject_id)
      activityData.response_id = item.activity_id ? item.id : null
      activityData.completed_at = item.completed_at ? item.completed_at : null
      activityData.user_id = item.user_id ? item.user_id : null

      return activityData
    })
    
    var activityDisplay = []
    var userIDs = this.sortUserIDs()
    _.each(userIDs, (userID) => {
      var rows = _.map(this.sortExercises(_.where(allExerciseData, {user_id: userID})), (exercise) => {
        var activity = _.find(this.props.activities, { id: exercise.activity_id })
        if (exercise) {
          var assigned = <td></td>
          if (exercise && exercise.created_at) {
            assigned = <td>{this.dateFormat(exercise.created_at)}</td>
          }

          var dueDate = <td></td>
          var taskForExercise = _.find(this.props.tasks, { user_id: exercise.user_id, subject_id: exercise.text_id })
          if (exercise && exercise.due_date) {
            dueDate = <td>{this.dateFormat(exercise.due_date)}</td>
          } else if (taskForExercise && taskForExercise.due_date) {
            dueDate = <td>{this.dateFormat(taskForExercise.due_date)}</td>
          }

          var textTitle = <td></td>
          if (exercise.text_id !== 'MISSING_TEXT_ID' && exercise.text_id !== '') {
            var book = _.find(this.props.books, { text_id: exercise.text_id })
            if (book) {
              textTitle = <td>{book.title}</td>
            }
          }

          var activityTitle = <td></td>
          if (activity && activity.format_summary && activity.format_summary.title) {
            var activityTitle = <td>{activity.format_summary.title}</td>
          }

          var skillSet = <td></td>
          if (activity && activity.format_summary && activity.format_summary.skillset) {
            skillSet = <td>{Skillsets.getName(activity.format_summary.skillset)}</td>
          }

          var format = <td></td>
          if (activity && activity.format_summary && activity.format_summary.format_class) {
            format = <td>{Formats.getName(activity.format_summary.format_class)}</td>
          }

          var complete = <td className={'iconContainer'}><Glyphicon icon='glyphicon glyphicon-unchecked icon-gray' /></td>
          if (exercise.completed_at && exercise.response_id) {
            complete = (
              <td className={'iconContainer'}>
                <Glyphicon icon='glyphicon glyphicon-check icon-green' />
                <a className={'viewLink'} onClick={this.handleActivityClick} data-response-id={exercise.response_id}>View</a>
              </td>)
          }

          return (
            <tr key={exercise.created_at + '_' + exercise.user_id + '_' + exercise.activity_id}>
              {assigned}
              {dueDate}
              {textTitle}
              {activityTitle}
              {skillSet}
              {format}
              {complete}
            </tr>
          )
        }
      });

      rows = _.compact(rows);

      var studentTable = ''
      if (rows.length) {
        studentTable = (
          <div className="StudentActivitiesTable" key={userID + '_' + this.props.key}>
            <StudentDisplay studentID={userID} showAvatar avatarMaxWidth={40} />
            <table className="table table-bordered">
              <tbody>
                <tr>
                  <th data-tip="Most recent date of any activity during time period">
                    Assigned
                  </th>
                    <th className="dueDateCol">
                      Due Date
                  </th>
                    <th className="textTitleCol">
                      Text Title
                  </th>
                    <th className="exerciseTitleCol">
                      Exercise Title
                  </th>
                    <th className="skillSetCol">
                      Skill Set
                  </th>
                    <th className="formatCol">
                      Format
                  </th>
                    <th className="completeCol">
                      Complete
                  </th>
                </tr>
                {rows}
              </tbody>
            </table>
          </div>
        );
        activityDisplay.push(studentTable);
      }
    })

    var noExercises = ''
    // filter user ids for users without assigned or completed exercises
    var contentType = this.props.assigned ? 'Assigned Exercises' : 'Completed Exercises'
    var userIDs = this.props.assigned ? this.state.studentsWithoutExercises : this.state.studentsWithoutCompletedExercises
    if (userIDs.length) {
      noExercises = <NoActivityBlock userIDs={userIDs} contentType={contentType} />
    }

    return (
      <div className="expandedStudentActivitiesTable" key={this.props.key}>
        {this.renderSortContainer(activityDisplay)}
        {activityDisplay}
        {noExercises}
      </div>
    )
  }
}

var LAST_ACTIVE = "last-active";
var STUDENT_NAME_ORDER = "student-name";
var ASSIGNED_DATE = "assigned-date";
var DUE_DATE = "due-date";

var ACTIVITY_SUBJECT_TYPE = "Activity"


ExpandedStudentActivitiesTable.WrappedComponent.propTypes = StrictPropTypes({
  userID: PropTypes.number,
  userIDs: PropTypes.array,
  students: PropTypes.array,
  startDate: PropTypes.string,
  endDate: PropTypes.string,
  textVariety: PropTypes.string,
  textID: PropTypes.string,
  showFullData: PropTypes.bool,
  assigned: PropTypes.bool,
  completed: PropTypes.bool,
  includeAllActivities: PropTypes.bool,
  // List of activities
  activities: PropTypes.array,
  activityTasks: PropTypes.array,
  books: PropTypes.array,
  tasks: PropTypes.array,
  // List of responses
  responses: PropTypes.array,
  // Data from @connect
  loading: PropTypes.bool,
  // Handlers from @connect
  populateData: PropTypes.func,
  fetchActivity: PropTypes.func,
  fetchBook: PropTypes.func,
  toggleExpandedResponse: PropTypes.func,
});

module.exports = ExpandedStudentActivitiesTable


// WEBPACK FOOTER //
// ./modules/components/writing/activities/ExpandedStudentActivitiesTable.js